// DS: DS4.2, DS4.2.1
import React from 'react';
import c from 'classnames';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import CheckIcon from '../Icons/Check';
import s from './Checkbox.scss';
export const Checkbox = ({ id , name , size ='big' , children , isChecked , hasError , halfChecked , className , labelClassName , innerRef , disabled , ariaLabel , ariaLabelledBy , onChange , biData  })=>{
    const icon = isChecked && halfChecked ? /*#__PURE__*/ React.createElement("div", {
        className: c(s['icon'], s['icon-dash'])
    }) : /*#__PURE__*/ React.createElement(CheckIcon, {
        className: c(s['icon'], s['icon-check']),
        customSizable: true
    });
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], isChecked && s['checked'], disabled && s['disabled'], hasError && s['has-error'], s[`size-${size}`], className),
        onClick: (e)=>onChange && onChange(!isChecked, e)
    }, /*#__PURE__*/ React.createElement(BiInput, {
        type: "checkbox",
        id: id,
        name: name,
        checked: isChecked,
        disabled: disabled,
        onChange: (event)=>onChange && onChange(event.target.checked, event),
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        biData: biData,
        innerRef: innerRef
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['checkbox']
    }, icon), children && /*#__PURE__*/ React.createElement("span", {
        className: c(s['label'], labelClassName)
    }, children));
};
Checkbox.displayName = 'Checkbox';
export default Checkbox;
